import React from 'react';
import {
	ApHeaderBar,
	colors,
	ApMenuItem,
	ApMenuUser,
} from '@alixpartners/ui-components';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';
import get from 'lodash/get';

const getInitials = fullName => {
	return fullName
		.split(' ')
		.map(n => n[0])
		.join('');
};

export const DefaultHeader = ({ user, logout }) => {
	let baseUrl = '/';

	try {
		const appUrls = JSON.parse(process.env.REACT_APP_URLS || '');
		baseUrl = appUrls.Main.Ui;
	} catch (e) {
		console.error('can not parse REACT_APP_URLS', e);
	}

	return (
		<ApHeaderBar
			application={{
				color: colors.green4,
				shortTitle: 'SXR',
				title: 'Spend X-Ray',
			}}
			baseUrl={baseUrl}
			rightMenu={() => (
				<ApMenuUser
					initials={user ? getInitials(get(user, 'profile.name')) : ''}
				>
					{logout && <ApMenuItem onClick={logout}>Logout</ApMenuItem>}
				</ApMenuUser>
			)}
		/>
	);
};

export default props => (
	<ApAuthenticationContextConsumer>
		{({ user, logout }) => (
			<DefaultHeader user={user} logout={logout} {...props} />
		)}
	</ApAuthenticationContextConsumer>
);
